angular.module('SpidApp')

.factory('BusinessDay',
[
function () {
	var BusinessDay = function (params) {
		params = params || {}

		this.isoDate   = params.date;
		this.cash      = params.cash;
		this.sum      = params.sum;
		this.agencyId  = params.agency_id
		this.validated = !!params.validated || false
	}
	
	BusinessDay.prototype.setValidated = function () {
		this.validated = true
	}

	BusinessDay.prototype.setUnvalidated = function () {
		this.validated = false
	}

	BusinessDay.prototype.isValidated = function () {
		return this.validated
	}

	return BusinessDay
}])